import { WebSocketContext } from "@/contexts";
import { useContext } from "react";

export const useWebSocket = () => {
  const socket = useContext(WebSocketContext);
  return socket;
};
